export const TERMS_LINK = 'https://www.sravni.ru/promo/soglasie-na-obrabotku-personalnyh-dannyh/';
